var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import apis from 'apis/sandbox';
import globalConstants from '../constants/global-constants';
// ===== Extend Sandbox =====
var extendSandbox = function (accessToken, data, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var error, _a, err, sandboxes;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, apis.extendSandboxByHash(accessToken, data)];
            case 1:
                error = (_b.sent())[0];
                if (error)
                    return [2 /*return*/, cb(error)];
                return [4 /*yield*/, apis.getUserRunningInstance(accessToken)];
            case 2:
                _a = _b.sent(), err = _a[0], sandboxes = _a[1];
                cb(err || error, sandboxes);
                return [2 /*return*/, null];
        }
    });
}); };
export var beginExtend = function (accessToken, data) { return function (dispatch) {
    dispatch({
        type: 'EXTEND_SANDBOX',
        extendSandboxHashKey: data.sandboxHashKey,
    });
    extendSandbox(accessToken, data, function (error, sandboxes) {
        dispatch({
            type: error ? 'EXTEND_SANDBOX_FAILED' : 'EXTEND_SANDBOX_SUCCESS',
            error: error,
            sandboxes: sandboxes,
            sandbox: data,
        });
    });
}; };
// ===== TERMINATE SANDBOX =====
var terminateSandbox = function (accessToken, sandbox, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!globalConstants.testing.terminate) return [3 /*break*/, 1];
                setTimeout(function () {
                    var error = false;
                    cb(error);
                }, 5000);
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, apis.terminateSandboxInstance(accessToken, sandbox.sandboxHashKey)];
            case 2:
                _a = _b.sent(), error = _a[0], data = _a[1];
                cb(error, data);
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var beginTermination = function (accessToken, sandbox) { return function (dispatch) {
    dispatch({
        type: 'TERMINATE_SANDBOX',
        sandboxHashKey: sandbox.sandboxHashKey,
    });
    terminateSandbox(accessToken, sandbox, function (error) {
        dispatch({
            type: error ? 'TERMINATE_SANDBOX_FAILED' : 'TERMINATE_SANDBOX_SUCCESS',
            error: error,
            sandbox: sandbox,
        });
    });
}; };
// ===== inviteTo SANDBOX =====
var inviteToSandbox = function (accessToken, params, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, apis.inviteToSandbox(accessToken, params)];
            case 1:
                _a = _b.sent(), error = _a[0], response = _a[1];
                cb(error, response);
                return [2 /*return*/];
        }
    });
}); };
export var beginInvition = function (accessToken, params) { return function (dispatch) {
    dispatch({
        type: 'INVITE_TO_SANDBOX',
    });
    inviteToSandbox(accessToken, params, function (error, response) {
        dispatch({
            type: error ? 'INVITE_TO_SANDBOX_FAILED' : 'INVITE_TO_SANDBOX_SUCCESS',
            inviteData: response.data,
        });
    });
}; };
// ===== INVITATION ACCPET =====
var invitationAccept = function (accessToken, invitationCode, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, apis.acceptInvitation(accessToken, invitationCode)];
            case 1:
                _a = _b.sent(), error = _a[0], response = _a[1];
                cb(error, response);
                return [2 /*return*/];
        }
    });
}); };
export var beginInvitationAccept = function (accessToken, invitationCode) { return function (dispatch) {
    dispatch({
        type: 'ACCEPT_INVITATION',
    });
    invitationAccept(accessToken, invitationCode, function (error, response) {
        dispatch({
            type: error || !response.data.token
                ? 'ACCEPT_INVITATION_FAILED'
                : 'ACCEPT_INVITATION_SUCCESS',
            data: response.data,
        });
    });
}; };
// ===== PUSH TO AURA =====
var pushToAura = function (accessToken, params, cb) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, apis.pushToAura(accessToken, params)];
            case 1:
                _a = _b.sent(), error = _a[0], response = _a[1];
                cb(error, response);
                return [2 /*return*/];
        }
    });
}); };
export var beginPush = function (accessToken, params) { return function (dispatch) {
    dispatch({
        type: 'PUSH_TO_AURA',
    });
    dispatch({
        type: 'STARTED_PUSH_TO_AURA_REQUEST',
    });
    pushToAura(accessToken, params, function (error, response) {
        dispatch({
            type: error ? 'PUSH_TO_AURA_FAILED' : 'PUSH_TO_AURA_SUCCESS',
            auraPushResponseData: response.data,
        });
    });
}; };
export var pendingFinished = function () { return function (dispatch) {
    dispatch({
        type: 'FINISHED_PUSH_TO_AURA_REQUEST',
    });
}; };
// ===== DOWNLOAD CREDENTIALS =====
export var downloadCredentialsSuccess = function () { return function (dispatch) {
    dispatch({
        type: 'DOWNLOADING_CREDENTIALS_SUCCESS',
    });
    dispatch({
        type: 'DOWNLOADING_CREDENTIALS_FINISHED',
    });
}; };
export var downloadCredentialsFailed = function () { return function (dispatch) {
    dispatch({
        type: 'DOWNLOADING_CREDENTIALS_FAILED',
    });
}; };
